import { buildAudioRefCandidates, normalizeAudioRef } from "./audioRefUtils";
import repairedAudioRefreshPolicy from "./audioRepairRefreshPolicy.generated.json";
import repairedAudioRefreshPolicy20261014 from "./audioRepairRefreshPolicy20261014.generated.json";
import repairedAudioRefreshPolicy20261013 from "./audioRepairRefreshPolicy20261013.generated.json";
import repairedAudioRefreshPolicy20261012TargetLanguageNames from "./audioRepairRefreshPolicy20261012TargetLanguageNames.generated.json";
import repairedAudioRefreshPolicy20261012 from "./audioRepairRefreshPolicy20261012.generated.json";
import repairedAudioRefreshPolicy20261012CanName from "./audioRepairRefreshPolicy20261012CanName.generated.json";

const AUDIO_REF_REFRESHED_AFTER_UTC: Record<string, string> = {
  "audio/en/a1/communication_repair_problem_solving/confirming_understanding/s_so_its_fifteen_dollars.mp3": "2026-10-09T18:41:00.000Z",
  "audio/en/a1/services_public_interactions/cafe_coffee_shop/s_hi.mp3": "2026-10-09T18:41:00.000Z",
  "audio/en/a1/social_interaction/greeting/s_im_fine_thanks.mp3": "2026-10-09T18:10:00.000Z",
  "audio/en/a1/social_interaction/small_talk/s_is_it_sunny_outside.mp3": "2026-10-09T18:41:00.000Z",
  "audio/ar/b1/social_interaction/b1_si_extended_self_expression/s_hl_mrrt_btjrba_tshbh_hdhh_mn_qbl.mp3": "2026-08-31T21:27:19.000Z",
  "audio/ar/a1/social_interaction/greeting/s_ahla_kyf_halk_hdha_almsaa.mp3": "2026-05-13T00:00:00.000Z",
  "audio/ar/a1/social_interaction/greeting/s_msawk_sayd.mp3": "2026-05-13T00:00:00.000Z",
  "audio/ar/a1/social_interaction/greeting/s_msawkm_sayd.mp3": "2026-05-13T00:00:00.000Z",
  "audio/it/a1/communication_repair_problem_solving/asking_for_help_language/s_no_grazie.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a1/daily_life/basic_needs/s_no_grazie.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a1/daily_life/food_drink/s_no_grazie.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a1/daily_life/likes_dislikes/s_no_grazie.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a1/daily_life/shopping_basics/s_no_grazie.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a1/daily_life/short_responses/s_no_grazie.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a1/daily_life/simple_questions/s_perche_no.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a1/daily_life/transport_basics/s_no_grazie.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a1/daily_life/what_you_can_do/s_no_grazie.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a1/services_public_interactions/cafe_coffee_shop/s_no_grazie.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a1/services_public_interactions/hotel/s_no_thank_you.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a1/services_public_interactions/phone_basic_contact/vocab_nessun_problema.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a1/services_public_interactions/phone_basic_contact/vocab_no_problem.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a1/services_public_interactions/restaurant/s_no_grazie.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a2/daily_life/shopping_expanded/s_no_grazie.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a2/social_interaction/decision_making_and_suggestions/s_perche_no.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a2/social_interaction/decision_making_and_suggestions/vocab_perche_no.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a2/social_interaction/polite_requests_offers/s_no_grazie.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a2/social_interaction/polite_requests_offers/vocab_no_grazie.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/b2/social_interaction/diplomatic_language_politeness/vocab_dire_di_no.mp3": "2026-06-13T00:00:00.000Z",
  "audio/it/a1/communication_repair_problem_solving/basic_miscommunication/vocab_bar.mp3": "2026-10-10T20:25:19.000Z",
  "audio/it/a1/daily_life/daily_activities/vocab_bar.mp3": "2026-10-10T20:25:19.000Z",
  "audio/it/a1/daily_life/directions_basics/vocab_bar.mp3": "2026-10-10T20:25:19.000Z",
  "audio/it/a1/daily_life/future_plans/vocab_bar.mp3": "2026-10-10T20:25:19.000Z",
  "audio/it/a1/daily_life/time_routine/vocab_bar.mp3": "2026-10-10T20:25:19.000Z",
  "audio/it/a2/communication_repair_problem_solving/fixing_miscommunication/vocab_bar.mp3": "2026-10-10T20:25:19.000Z",
  "audio/it/a2/daily_life/asking_better_questions/vocab_bar.mp3": "2026-10-10T20:25:19.000Z",
  "audio/it/a2/daily_life/comparisons_real_use/vocab_bar.mp3": "2026-10-10T20:25:19.000Z",
  "audio/it/a2/daily_life/describing_places_detailed/vocab_bar.mp3": "2026-10-10T20:25:19.000Z",
  "audio/it/a2/daily_life/existence/vocab_bar.mp3": "2026-10-10T20:25:19.000Z",
  "audio/it/a2/daily_life/prepositions/vocab_bar.mp3": "2026-10-10T20:25:19.000Z",
  "audio/it/a2/social_interaction/extended_introductions/vocab_bar.mp3": "2026-10-10T20:25:19.000Z",
  "audio/it/a2/social_interaction/inviting_and_responding/vocab_bar.mp3": "2026-10-10T20:25:19.000Z",
  "audio/tr/a1/social_interaction/greeting/s_iyidir.mp3": "2026-07-12T00:00:00.000Z",
  "audio/tr/a1/social_interaction/greeting/s_ben_de_memnun_oldum.mp3": "2026-08-13T19:04:00.000Z",
  "audio/tr/a1/social_interaction/greeting/s_gunaydin.mp3": "2026-08-13T19:04:00.000Z",
  "audio/tr/a1/social_interaction/greeting/s_gunaydin_hos_geldin.mp3": "2026-08-13T19:04:00.000Z",
  "audio/tr/a1/social_interaction/greeting/s_gunaydin_nasilsin.mp3": "2026-08-13T19:04:00.000Z",
  "audio/tr/a1/social_interaction/greeting/s_iyiyim_sag_ol.mp3": "2026-08-13T19:04:00.000Z",
  "audio/tr/a1/social_interaction/greeting/s_iyiyim_ya_sen.mp3": "2026-08-13T19:04:00.000Z",
  "audio/tr/a1/social_interaction/greeting/s_merhaba.mp3": "2026-08-13T19:04:00.000Z",
  "audio/tr/a1/social_interaction/greeting/s_merhaba_ben_ayse.mp3": "2026-08-13T19:04:00.000Z",
  "audio/tr/a1/social_interaction/greeting/vocab_gunaydin.mp3": "2026-08-13T19:04:00.000Z",
  "audio/tr/a1/social_interaction/greeting/vocab_merhaba.mp3": "2026-08-13T19:04:00.000Z",
  "audio/tr/a1/social_interaction/greeting/vocab_ne_haber.mp3": "2026-08-13T19:04:00.000Z",
};

const REPAIRED_AUDIO_REFRESH_POLICIES = [
  repairedAudioRefreshPolicy20261014,
  repairedAudioRefreshPolicy20261013,
  repairedAudioRefreshPolicy20261012TargetLanguageNames,
  repairedAudioRefreshPolicy20261012CanName,
  repairedAudioRefreshPolicy20261012,
  repairedAudioRefreshPolicy,
].map(policy => ({
  cutoffUtc: policy.cutoffUtc,
  audioRefs: new Set<string>(policy.audioRefs.map(audioRef => normalizeAudioRef(audioRef))),
}));

export function resolveAudioRefRefreshCutoff(audioRef: string): string | null {
  for (const candidate of buildAudioRefCandidates(audioRef)) {
    const normalizedCandidate = normalizeAudioRef(candidate);
    for (const policy of REPAIRED_AUDIO_REFRESH_POLICIES) {
      if (policy.audioRefs.has(normalizedCandidate)) {
        return policy.cutoffUtc;
      }
    }
    if (AUDIO_REF_REFRESHED_AFTER_UTC[normalizedCandidate]) {
      return AUDIO_REF_REFRESHED_AFTER_UTC[normalizedCandidate];
    }
  }
  return null;
}

export function shouldRefreshPersistedAudioRef(audioRef: string, persistedUpdatedAt: string | undefined): boolean {
  const cutoff = resolveAudioRefRefreshCutoff(audioRef);
  if (!cutoff) {
    return false;
  }
  const cutoffTime = Date.parse(cutoff);
  const persistedTime = Date.parse(String(persistedUpdatedAt || ""));
  if (!Number.isFinite(cutoffTime)) {
    return false;
  }
  return !Number.isFinite(persistedTime) || persistedTime < cutoffTime;
}
